import {
  TmDialogElement,
  TmDialogElementStyle,
} from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles, tag } from './content.styles';

@customElement(tag)
export class ContentModalComponent extends TmDialogElement {
  override contained = true;

  static override styles = [TmDialogElementStyle, styles];

  protected override allContents() {
    return html`
      <div part="content-wrapper" class="content-wrapper">
        ${super.allContents()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-content-modal': ContentModalComponent;
  }
}
